import { useQuery } from "@tanstack/react-query";

import { configService } from "../services/configService";
import { useAuth } from "./useAuth";

export const useShowCallStart = () => {
  const { isAdmin } = useAuth();

  const { data: configs } = useQuery({
    queryKey: ["configs"],
    queryFn: () => configService.getConfigsApp(),
    enabled: isAdmin,
  });

  return isAdmin && !!configs?.callStart;
};
